document.addEventListener("DOMContentLoaded", () => {
  const downloadTitles = document.querySelectorAll(".download-item-title");
  const closeBtns = document.querySelectorAll(".download-close-btn");
  const downloadBoxs = document.querySelectorAll(".download-item-container-layout");

  downloadTitles.forEach(function (item) {
    item.addEventListener("click", function () {
      const downloadBox = item.nextElementSibling;

      if (downloadBox) {
        downloadBox.classList.add("active");
      }
    });
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      downloadBoxs.forEach(function (item) {
        if (item.classList.contains("active")) {
          item.classList.remove("active");
        }
      });
    });
  });


  // 搜索功能
  const searchInput = document.querySelector(".download-search-input");
  const searchBtn = document.querySelector(".download-search-btn");
  const downloadItems = document.querySelectorAll(".download-item");
  const downloadLayouts = document.querySelectorAll(".download-layout");

  function handleSearch() {
    const searchText = searchInput.value.trim().toLowerCase();

    downloadItems.forEach((item) => {
      const dataTitle = item.dataset.title.toLowerCase();
      if (dataTitle.includes(searchText)) {
        item.classList.remove("hide");
      } else {
        item.classList.add("hide");
      }
    });

    downloadLayouts.forEach((layout) => {
      const itemsInLayout = layout.querySelectorAll(".download-item");
      const allHidden = Array.from(itemsInLayout).every((item) =>
        item.classList.contains("hide")
      );

      if (allHidden) {
        layout.classList.add("hide");
      } else {
        layout.classList.remove("hide");
      }
    });
  }

  searchBtn.addEventListener("click", handleSearch);
  searchInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  });

});
